import React from 'react';

const Entry = ({ image, summary, active = false }) => (
    <div style={{ display: active ? 'block' : 'none' }}>
    <img className="c-History__image" src={image} />
    <p className="c-History__summary">{summary}</p>
    </div>
);

export default Entry



// WEBPACK FOOTER //
// ./plugins/app/site/pagesections/history/js/Entry.js